export const tracking = {
  metaPixelId: '2335234447313587',
};
